import React, { useState, useRef, useEffect } from "react";
import "./carousel.css";

const Carousel = ({ items, selected }) => {
  const [activeIndex, setActiveIndex] = useState(
    selected === -1 ? 0 : selected
  );
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [offset, setOffset] = useState(0);
  const trackRef = useRef(null);

  useEffect(() => {
    const handleTouchMove = (e) => {
      if (!isDragging || !e.touches[0]) return;
      const deltaX = e.touches[0].clientX - startX;
      setOffset(deltaX);
    };

    const handleTouchEnd = () => {
      if (!isDragging) return;
      setIsDragging(false);

      if (offset > 50 && activeIndex > 0) {
        setActiveIndex(activeIndex - 1);
      } else if (offset < -50 && activeIndex < items.length - 1) {
        setActiveIndex(activeIndex + 1);
      }
      setOffset(0);
    };

    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [isDragging, startX, offset, activeIndex, items.length]);

  const handleTouchStart = (e) => {
    if (!e.touches[0]) return;
    setIsDragging(true);
    setStartX(e.touches[0].clientX);
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="carousel-container">
      <div
        className="carousel-track"
        ref={trackRef}
        onTouchStart={handleTouchStart}
        style={{
          transform: `translateX(calc(-${
            activeIndex * 105
          }% + ${offset}px - 10px))`,
          transition: isDragging ? "none" : "transform 0.3s ease",
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            className={`carousel-card ${index === activeIndex ? "active" : ""}`}
          >
            {item}
          </div>
        ))}
      </div>
      <div className="carousel-dots">
        {items.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? "active-dot" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
